import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import React, { FC, ReactNode } from 'react'

interface IconItemProps {
  iconSource: string
  itemText: ReactNode
}

export const IconItem: FC<IconItemProps> = ({ iconSource, itemText }) => (
  <Box textAlign='center' maxWidth='30rem' m='auto'>
    <img src={ iconSource } alt='' width='144' />
    <Box my={ 5 }>
      <Typography variant='h3' color='textPrimary'>{ itemText }</Typography>
    </Box>
  </Box>
)
